import { HttpClientModule } from '@angular/common/http';
import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { CookieModule } from 'ngx-cookie';
import { AdswapperTracking } from './adswapper-tracking';
import { CoreWebVitalsTrackingComponent } from './core-web-vitals-tracking.component';
import { ErrorTrackingComponent } from './error-tracking.component';
import { FacebookPixelTracking } from './facebook-pixel-tracking.service';
import { GoogleTracking } from './google-tracking.service';
import { HeartbeatTrackingComponent } from './heartbeat-tracking.component';
import { HotjarUserAttributesComponent } from './hotjar-user-attributes.component';
import { HotjarComponent } from './hotjar.component';
import { Hotjar } from './hotjar.service';
import { LinkedInPixelTracking } from './linkedIn-pixel-tracking.service';
import { LongTaskTrackingComponent } from './long-task-tracking.component';
import { MemoryTrackingComponent } from './memory-tracking.component';
import { MgidTracking } from './mgid-tracking.service';
import { NavigationPerformanceTrackingComponent } from './navigation-performance-tracking.component';
import { PageViewTrackingComponent } from './page-view-tracking.component';
import { PerformanceTracking } from './performance-tracking.service';
import { QuoraPixelTracking } from './quora-pixel-tracking.service';
import { SpinnerHeartbeatDirective } from './spinner-heartbeat.directive';
import { SyntheticPerformanceTrackingComponent } from './synthetic-performance-tracking.component';
import { TrackingSectionDirective } from './tracking-section.directive';
import { TrackingComponent } from './tracking.component';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingDirective } from './tracking.directive';
import type { TrackingConfig } from './tracking.interface';
import { Tracking } from './tracking.service';
import { UserTimingTrackingComponent } from './user-timing-tracking.component';

@NgModule({
  imports: [HttpClientModule, CookieModule],
  declarations: [
    CoreWebVitalsTrackingComponent,
    ErrorTrackingComponent,
    HeartbeatTrackingComponent,
    HotjarComponent,
    HotjarUserAttributesComponent,
    LongTaskTrackingComponent,
    MemoryTrackingComponent,
    NavigationPerformanceTrackingComponent,
    PageViewTrackingComponent,
    SpinnerHeartbeatDirective,
    SyntheticPerformanceTrackingComponent,
    TrackingComponent,
    TrackingDirective,
    TrackingSectionDirective,
    UserTimingTrackingComponent,
  ],
  exports: [
    HeartbeatTrackingComponent,
    HotjarComponent,
    HotjarUserAttributesComponent,
    SpinnerHeartbeatDirective,
    TrackingComponent,
    TrackingDirective,
    TrackingSectionDirective,
  ],
  providers: [
    AdswapperTracking,
    FacebookPixelTracking,
    GoogleTracking,
    Hotjar,
    LinkedInPixelTracking,
    MgidTracking,
    PerformanceTracking,
    QuoraPixelTracking,
  ],
})
export class TrackingModule {
  static initialize(
    config: TrackingConfig,
  ): ModuleWithProviders<TrackingModule> {
    return {
      ngModule: TrackingModule,
      providers: [Tracking, { provide: TRACKING_CONFIG, useValue: config }],
    };
  }
}
